export var NOTIFICATION_DISPLAY = "NOTIFICATION_DISPLAY";
export var NOTIFICATION_HIDE = "NOTIFICATION_HIDE";
